<template>
  <div class="mt-6 border-t-2 border-gray-200 pt-6">
    <dl>
      <div>
        <dt class="text-lg leading-7">
          <!-- Expand/collapse question button -->
          <button
            class="text-left w-full flex justify-between items-start text-gray-400 focus:outline-none focus:text-gray-900"
            @click="isOpen = !isOpen"
          >
            <span class="font-medium text-gray-900">
              {{ title }}
            </span>
            <span class="ml-6 h-7 flex items-center">
              <!--
                    Heroicon name: chevron-down

                    Open: "-rotate-180", Closed: "rotate-0"
                  -->
              <svg
                class=" h-6 w-6 transform"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                :class="{ '-rotate-180': isOpen, 'rotate-0': !isOpen }"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </span>
          </button>
        </dt>
        <dd class="mt-2 pr-12" v-show="isOpen">
          <p class="text-base leading-6 text-gray-500">
            {{ content }}
          </p>
        </dd>
      </div>
    </dl>
  </div>
</template>

<script>
export default {
  name: "AccordianItem",
  props: {
    title: {
      type: String
    },
    content: {
      type: String
    }
  },
  data() {
    return {
      isOpen: false
    };
  }
};
</script>

<style lang="scss" scoped></style>
